<template>
  <main class="page-map">
    <div class="page-container">
      <div class="nav-back">
        <a role="button" @click="$router.go(-1)"><i class="las la-arrow-left"></i></a>
      </div>
      <div class="fullwidth-map">
        <iframe width="600" height="373.5" src="https://app.powerbi.com/view?r=eyJrIjoiMTdkOTZjZmItM2UzOC00NzVkLTljOWUtYmQwMjZmNjBjZTRjIiwidCI6IjMxZmNmYjNmLThhMGItNGFiNS1iNzkyLTc0YzkwNjJiOWM4ZSIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
      </div>
    </div>
  </main>
</template>

<script>
import PageBaseMixin from '@/mixins/PageBase';

export default {
  mixins: [PageBaseMixin],
  title: 'Mapa interactivo | Escuela de liderazgo',
}

</script>

<style lang="scss" scoped>
.page-map
{
  .page-container
  {
    max-width: 1400px;
    width: 100%;
    margin: 0 auto;
  }
  
  .fullwidth-map
  {
    position: relative;
    padding-bottom: (37400% / 600);
    // max-width: 1200px;
    // margin: 0 auto;
  }

  IFRAME
  {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
}
</style>